import React from 'react';
import NextLink from 'next/link';

const LinkBehaviour = React.forwardRef(function linkBehaviour(props, ref) {
  const linkProps = {...props};

  if(!linkProps.href && !!props.to){
    linkProps.href = props.to;
  }

  return <NextLink ref={ref} {...linkProps} />;
});

export default LinkBehaviour;
